import {
    FETCH_JOURNEYS_START,
    FETCH_JOURNEYS_SUCCESS,
    FETCH_JOURNEYS_FAILED,
    FETCH_SPECIFIC_JOURNEY_START,
    FETCH_SPECIFIC_JOURNEY_SUCCESS,
    FETCH_SPECIFIC_JOURNEY_FAILED,
    FETCH_IN_PROGRESS_JOURNEYS_SUCCESS,
    FETCH_IN_PROGRESS_JOURNEYS_START,
    FETCH_IN_PROGRESS_JOURNEYS_FAILED,
    FETCH_JOURNEY_USER_PROGRESS_START,
    FETCH_JOURNEY_USER_PROGRESS_SUCCESS,
    PATCH_USER_PROGRESS,
    FETCH_COMPLETED_JOURNEYS_START,
    FETCH_COMPLETED_JOURNEYS_FAILED, FETCH_COMPLETED_JOURNEYS_SUCCESS
} from "./JourneyTypes";
import {queryJourneys} from "../../screens/journeyStack/api/methods/queryJourneys";
import {getJourney} from "../../screens/journeyStack/api/methods/getJourney";
import {queryInProgressJourneys} from "../../screens/journeyStack/api/methods/queryInProgressJourneys";
import {subToJourney} from "../../screens/journeyStack/api/methods/subscribeToJourney";
import {fetchJourneyItemsUserProgress} from "../../screens/journeyStack/api/methods/fetchJourneyItemsUserProgress";
// import {resolveIcon} from "../../screens/journeyStack/timeline/TimelineResolveIcon";
import patch from "../../api/methods/patch";
import {JOURNEY_COMPLETE, JOURNEY_PATCH_PROGRESS} from "../../screens/journeyStack/api/journeyEndpoints";
import post from "../../api/methods/post";
import {queryCompletedJourneys} from "../../screens/journeyStack/api/methods/queryCompletedJourneys";

export const fetchJourneys = () => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCH_JOURNEYS_START });
        try {

            const state = getState();

            const group = state.user.group;
            const groupId = state.user.groupId;
            let queryResult = await queryJourneys(groupId);

            //
            // let availableJourneys = queryResult.Items.filter(i => {
            //     console.log(i);
            //     console.log(i.groups)
            //
            //     if (i.groups.length === 0)
            //         return i;
            //
            //     if (groupId !== null)
            //         if (i.groups.includes(groupId))
            //             return i;
            //
            // })
            //
            // console.log(availableJourneys);

            dispatch({ type: FETCH_JOURNEYS_SUCCESS, payload: queryResult });

        } catch (e) {
            console.log(e);
            dispatch({ type: FETCH_JOURNEYS_FAILED });
            throw e;
        }
    }
}

export const fetchSpecificJourney = (journeyId) => {
    return async (dispatch, getState) => {

        const currentJourney = getState().journey.currentJourney;

        if (currentJourney != null) {
            if (journeyId === currentJourney.id)
                return;
        }

        dispatch({ type: FETCH_SPECIFIC_JOURNEY_START });

        try {
            let getResult = await getJourney(journeyId);
            dispatch({ type: FETCH_SPECIFIC_JOURNEY_SUCCESS, payload: getResult });
        } catch (e) {
            console.log(e);
            dispatch({ type: FETCH_SPECIFIC_JOURNEY_FAILED });
        }
    }
}

export const fetchInProgressJourneys = (userId) => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCH_IN_PROGRESS_JOURNEYS_START })
        try {
            const currentUserId = userId !== undefined ? userId : getState().user.userId;
            let inProgressResult = await queryInProgressJourneys(currentUserId);
            dispatch({ type: FETCH_IN_PROGRESS_JOURNEYS_SUCCESS, payload: inProgressResult });
        } catch (e) {
            console.log(e);
            dispatch({ type: FETCH_IN_PROGRESS_JOURNEYS_FAILED });
            throw e;
        }
    }
}

export const fetchCompletedJourneys = (userId) => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCH_COMPLETED_JOURNEYS_START });
        try {

            const currentUserId = userId !== undefined ? userId : getState().user.userId;
            let inProgressResult = await queryCompletedJourneys(currentUserId);
            dispatch({ type: FETCH_COMPLETED_JOURNEYS_SUCCESS, payload: inProgressResult });

        } catch (e) {
            console.log(e);
            dispatch({ type: FETCH_COMPLETED_JOURNEYS_FAILED })
            throw e;
        }
    }
}

export const fetchJourneyAndUserProgress = (journeyId, userId) => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCH_JOURNEY_USER_PROGRESS_START });

        userId = userId === undefined ? getState().user.userId : userId;
        const uniqueId = journeyId === undefined ? getState().journey.currentJourney.id : journeyId;

        try {

            const result = await fetchJourneyItemsUserProgress(userId, uniqueId);
            let journeyData = result.data.journey;

            journeyData.items = journeyData.items.map(item => {
                const isCompleted = result.data.userProgress.progress.includes(item.id);
                return {
                    ...item,
                    icon: require('../../img/icons/checkIcon.png'),
                    isCompleted: isCompleted
                }
            })

            dispatch({
                type: FETCH_JOURNEY_USER_PROGRESS_SUCCESS,
                payload: {
                    journey: journeyData,
                    userProgress: result.data.userProgress
                }
            });

        } catch (e) {
            console.log(e);
        }

    }
}

export const completeJourney = () => {
    return async (dispatch, getState) => {
        try {

            const state = getState();
            const userId = state.user.userId;
            const journeyId = state.journey.currentJourney.id;

            const payload = {
                journeyId: journeyId,
                userId: userId
            };

            const postResult = await post(JOURNEY_COMPLETE, payload);

            await dispatch(fetchInProgressJourneys(userId));
            await dispatch(fetchCompletedJourneys(userId));

        } catch (e) {
            console.log(e);
        }
    }
}

export const addContentToUserProgress = (contentType, contentId, userGeneratedData) => {
    return async (dispatch, getState) => {

        try {

            const state = getState();
            const userId = state.user.userId;
            const journeyId = state.journey.currentJourney.id;

            const payload = {
                userId: userId,
                journeyId: journeyId,
                contentId: contentId,
                contentType: contentType,
                ...userGeneratedData
            }

            let result = await patch(JOURNEY_PATCH_PROGRESS, payload);
            let json = await result.json();

            if (json.data !== null )
                dispatch({ type: PATCH_USER_PROGRESS, payload: json.data });

        } catch (e) {
            console.log(e);
        }
    }
}

export const isSubscribed = (journeyId) => {
    return (dispatch, getState) => {

        const inProgressJourneys = getState().journey.userInProgressJourneys;
        const completedJourneys = getState().journey.userCompletedJourneys;

        const userJourneys = [...inProgressJourneys, ...completedJourneys];

        for (let journey of userJourneys) {
            if (journey.id === journeyId) return true;
        }

        return false;
    }
}


